<template>
  <div class="wrapper">
    <div id="about-team">
      <h1 class="title">Tím</h1>

      <h4>
        Los Kimonos je zohratý tím, ktorého členovia spolu pracovali na rôznych
        školských i mimoškolských projektoch. Väčšinu z nás užšie spojila
        výskumná orientácia na fakulte a vďaka nej sme sa viac spoznali nie len
        po osobnostnej stránke, ale aj po tej profesijnej. So zvyškom tímu sa
        osobne poznáme a vieme sa tiež na seba spoľahnúť. <br />
        Členovia našeho tímu v minulosti pracovali so širokým spektrom
        technológií. Na frontende sme okrem klasickej trojice (HTML, CSS,
        JavaScript) pracovali s technológiami React.js, Vue.js, WordPress. Čo sa
        týka backendu, máme skúsenosti s technológiami Node.js, Typescript, RoR,
        Python(Flask). Členovia našeho tímu sa taktiež venovali data science,
        machine learningu a neurónovým sieťam. Venujeme sa vývoju mobilných
        aplikácií (Flutter, Android native). Pracovali sme s mnohými
        databázovými technológiami, napríklad PostgeSQL, MongoDB, Redis, MySQL.
        Máme taktiež skúsenosti s DevOps technológiami, informatickou
        bezpečnosťou, low-level programovaním.
        <br />
      </h4>
    </div>
    <br />
    <div id="images">
      <div class="title">
        <h1 class="title">Členovia tímu</h1>
      </div>
      <br />
      <br />

      <div class="content-container">
        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="covid"
            @click="isQuarantined"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Marek Galinski</h3>
            <h4>
              <br />
              <br />
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="sandro"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Sandro Rybárik</h3>
            <h4>
              Manažér tímu<br />
              Frontend developer
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="kiko"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Kristián Balaj</h3>
            <h4>
              Manažér backend tímu<br />
              Backend developer
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="adam"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Adam Štuller</h3>
            <h4>
              Databázy, DevOps<br />
              Backend developer
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="ondro"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Ondrej Jedinák</h3>
            <h4>
              Hlavný tester<br />
              Backend developer
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="kubo"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Jakub Lackovič</h3>
            <h4>
              Analytik<br />
              Backend developer
            </h4>
          </div>
        </div>

        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="miso"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Michal Šoška</h3>
            <h4>
              Web dizajnér<br />
              Frontend developer
            </h4>
          </div>
        </div>
        <div
          class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
          style="max-width: 248px;"
          :class="{ 'text-center': responsive }"
        >
          <img
            :src="juro"
            alt="Thumbnail Image"
            class="img-raised rounded-circle"
            :class="{ 'responsive-image': responsive }"
          />
          <div class="member">
            <h3>Juraj Mečír</h3>
            <h4>
              Dokumentačný expert<br />
              Frontend developer
            </h4>
          </div>
        </div>
      </div>
      <modal v-if="classicModal" @close="classicModalHide">
        <template slot="header">
          <h2 class="text-danger">!!POZOR!!</h2>

          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="classicModalHide"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <h4>
            Vedúci tímu Los Kimonos odmieta nosiť rúško a preto sme ho museli
            karantenizovať. Aby bolo možné zobraziť jeho fotku bez rúška je
            potrebné súhlasiť s opatreniami hlavného hygienika. Ak s nimi
            nesúhlasíte, rúško bude vedúcemu nasadené proti jeho vôli.
          </h4>
          <div class="button-container">
            <md-button class="md-success" @click="classicModalHideMarek"
              >Súhlasím</md-button
            >
            <md-button class="md-danger " @click="classicModalHideMarekSRuskom"
              >Nesúhlasím</md-button
            >
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  data() {
    return {
      classicModal: false,
      image: require("@/assets/img/logo.png"),
      juro: require("@/assets/img/juro.jpg"),
      adam: require("@/assets/img/adam.jpg"),
      sandro: require("@/assets/img/sandro.jpg"),
      ondro: require("@/assets/img/ondro.jpg"),
      kiko: require("@/assets/img/kiko.jpg"),
      miso: require("@/assets/img/miso.jpg"),
      marek: require("@/assets/img/marek.jpg"),
      kubo: require("@/assets/img/kubo.jpg"),
      mareksruskom: require("@/assets/img/mareksruskom.jpg"),
      covid: require("@/assets/img/karantena.jpg"),
      responsive: false
    };
  },
  methods: {
    classicModalHideMarekSRuskom() {
      this.classicModal = false;
      this.covid = this.mareksruskom;
    },
    classicModalHide() {
      this.classicModal = false;
    },
    classicModalHideMarek() {
      this.classicModal = false;
      this.covid = this.marek;
    },
    isQuarantined() {
      if (this.covid !== this.marek && this.covid !== this.mareksruskom) {
        this.classicModal = true;
      }
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>

<style lang="css">
.button-container {
  grid-gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
